// extracted by mini-css-extract-plugin
module.exports = {"image-container":"styles_image-container__qvX7d","tag":"styles_tag__N7G8Q","tagIcon":"styles_tagIcon__ru3cQ","tagLabel":"styles_tagLabel__Hld7S"};